import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Eye, EyeOff } from "lucide-react";
import { changePassword } from "../services/change-password";
import { useAuth } from "../auth/AuthContext";
import { AuthLayout } from "../components/layout/AuthLayout";

function ChangePassword() {
  const [oldPassword, setOldPassword] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();
  const { user } = useAuth();
  const userId = user?.userId;

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    if (password !== confirmPassword) {
      setErrorMessage("Passwords do not match.");
      return;
    }
    const userData = {
      oldPassword,
      password,
      userId,
    };

    setLoading(true);
    try {
      const response = await changePassword(userData);
      if (response.succeeded) {
        navigate("/signin");
      } else {
        setErrorMessage(response.message);
      }
    } catch (error) {
      console.error("Error during sign-up:", error);
      setErrorMessage(
        "There is a issue in change password, contact your administrator"
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthLayout
      title={
        <>
          Change <span className="auth-title__accent">password</span>
        </>
      }
      subtitle="Change your password of existing account."
    >
      {errorMessage ? (
        <div className="auth-alert auth-alert--error" role="alert">
          {errorMessage}
        </div>
      ) : null}

      <form className="auth-form" onSubmit={handleSubmit}>
        <div className="auth-field">
          <label htmlFor="oldPassword" className="auth-field__label">
            Old Password
            <span className="req">*</span>
          </label>
          <input
            type="password"
            id="oldPassword"
            className="auth-field__input"
            placeholder="Old Password"
            value={oldPassword}
            onChange={(e) => setOldPassword(e.target.value)}
            autoComplete="current-password"
            required
          />
        </div>

        <div className="auth-field auth-password-wrap">
          <label htmlFor="password" className="auth-field__label">
            Password
            <span className="req">*</span>
          </label>
          <input
            type={showPassword ? "text" : "password"}
            id="password"
            className="auth-field__input"
            placeholder="Enter your password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            autoComplete="new-password"
            required
          />
          <button
            type="button"
            className="auth-password-toggle"
            onClick={() => setShowPassword(!showPassword)}
            aria-label={showPassword ? "Hide password" : "Show password"}
          >
            {showPassword ? <EyeOff /> : <Eye />}
          </button>
        </div>

        <div className="auth-field auth-password-wrap">
          <label htmlFor="confirm-password" className="auth-field__label">
            Confirm Password
            <span className="req">*</span>
          </label>
          <input
            type={showConfirmPassword ? "text" : "password"}
            id="confirm-password"
            className="auth-field__input"
            placeholder="Confirm password"
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
            autoComplete="new-password"
            required
          />
          <button
            type="button"
            className="auth-password-toggle"
            onClick={() => setShowConfirmPassword(!showConfirmPassword)}
            aria-label={showConfirmPassword ? "Hide password" : "Show password"}
          >
            {showConfirmPassword ? <EyeOff /> : <Eye />}
          </button>
        </div>

        <button
          type="submit"
          className={`auth-submit${loading ? " auth-submit--loading" : ""}`}
          disabled={loading}
        >
          {loading ? "Updating…" : "Change Password"}
        </button>
      </form>

      <p className="auth-footer-text">
        <button type="button" className="auth-link" onClick={() => navigate(-1)}>
          Go back
        </button>
      </p>
    </AuthLayout>
  );
}

export default ChangePassword;
